import { Component, Inject } from '@angular/core';
import { InboxService } from 'src/app/components/inbox/inbox.service';
import { DocumentData, EmailDocument } from '../../../document.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppFilesService } from 'src/app/services/app-files.service';
import { helper } from 'src/environments/helper';
import { EmailAttachment } from 'src/app/components/inbox/inbox.interface';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'app-open-email',
    templateUrl: './open-email.component.html',
    styleUrls: ['./open-email.component.scss']
})
export class OpenEmailComponent {
    helper = helper;
    isLoading = false;

    emailData!: EmailDocument;
    expandedHistoryMessages: Set<number> = new Set();
    currentView: 'detalii' | 'istoric' = 'detalii';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            emailData: EmailDocument,
        },
        private dialogRef: MatDialogRef<OpenEmailComponent>,
        private inboxService: InboxService,
        private appFilesService: AppFilesService,
        private sanitizer: DomSanitizer,
    ) {
        this.emailData = data.emailData;
    }

    getSafeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    downloadAttachment(attachment: any) {
        let fullPath = this.inboxService.downloadUrl + attachment.id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    print(id: number) {
        let fullPath = this.inboxService.printUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Print error: ', err);
                this.isLoading = false;
            })
    }

    printFile(id: number) {
        let fullPath = this.inboxService.printFileUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Print error: ', err);
                this.isLoading = false;
            })
    }

    toggleHistoryMessage(messageId: number) {
        if (this.expandedHistoryMessages.has(messageId)) {
            this.expandedHistoryMessages.delete(messageId);
        } else {
            this.expandedHistoryMessages.add(messageId);
        }
    }

    isHistoryMessageExpanded(messageId: number): boolean {
        return this.expandedHistoryMessages.has(messageId);
    }

    downloadHistoryAttachment(attachment: any, event: Event) {
        event.stopPropagation();

        let fullPath = this.inboxService.downloadUrl + attachment.id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            });
    }

    getPlainTextPreview(html: string, maxLength: number = 100): string {
        if (!html) return '';

        const tmp = document.createElement('DIV');
        tmp.innerHTML = html;
        const text = tmp.textContent || tmp.innerText || '';

        const cleanText = text.replace(/\s+/g, ' ').trim();

        if (cleanText.length > maxLength) {
            return cleanText.substring(0, maxLength) + '...';
        }

        return cleanText;
    }

    toggleView(event: MatButtonToggleChange) {
        this.currentView = event.value;
    }

    hasHistory(): boolean {
        return this.emailData.historyMessages && this.emailData.historyMessages.length > 0;
    }
}